/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement } from 'react';
import { gql, useQuery } from '@apollo/client';
import AccessAgreementPage from '../pre-study/pages/access-agreement-page';

type PreStudyQueryResponse = {
	participant: {
		enableNewTasks?: boolean;
	};
	preStudy: {
		welcome: string;
		legal: {
			content: string;
			consents: string[];
		};
		accessAgreement: {
			instructions: string;
			label: string;
		} | null;
	};
	studyRequirements: {
		requiresMobileApp: boolean;
		requiresWebExtension: boolean;
	};
};

const getModeratedPreStudyQuery = gql`
	query preStudy {
		preStudy {
			accessAgreement {
				instructions
				label
			}
		}
		studyRequirements {
			requiresMobileApp
			requiresWebExtension
		}
		participant {
			enableNewTasks
		}
	}
`;

const ModeratedAccessAgreement = (): ReactElement => {
	const { data: preStudyData } = useQuery<PreStudyQueryResponse>(getModeratedPreStudyQuery);

	const preStudy = preStudyData?.preStudy;
	const hasAccessAgreement = preStudy?.accessAgreement;

	if (!preStudyData) {
		return <div id="no-preStudy" />;
	}

	if (!hasAccessAgreement) {
		return <div id="no-access-agreement" />;
	}

	return (
		<AccessAgreementPage
			isModerated
			label={preStudy?.accessAgreement?.label ?? ''}
			instructions={preStudy?.accessAgreement?.instructions ?? ''}
		/>
	);
};

export default ModeratedAccessAgreement;
